import { TextAlign } from './text-align.js'

export * from './text-align.js'

export default TextAlign
